import {
  Database,
  Mail,
  MessageSquare,
  Bell,
  Package,
  Truck,
  Plus,
  Minus,
  Calendar,
  FileText,
  Tag,
  User,
  RefreshCw,
  CheckCircle,
  MapPin,
  type LucideIcon,
} from 'lucide-react'

export const eventIcons: Record<string, LucideIcon> = {
  // ERP sync events
  erp_sync: Database,
  erp_created: Database,
  order_created: Plus,
  order_updated: RefreshCw,
  lines_added: Plus,
  lines_removed: Minus,
  status_changed: Package,
  delivery_date_changed: Calendar,
  info_changed: FileText,
  reference_changed: Tag,
  your_ref_changed: User,
  shipping_changed: Truck,
  // Purchase order events
  purchase_order_created: Package,
  purchase_order_sent: Truck,
  purchase_order_received: CheckCircle,
  purchase_order_partial: Package,
  purchase_order_email_sent: Mail,
  // App events
  order_prepared: MapPin,
  order_delivered: CheckCircle,
  // Legacy
  status_change: Package,
  email_sent: Mail,
  sms_sent: MessageSquare,
  notification: Bell,
  delivery: Truck,
}

export const eventLabels: Record<string, string> = {
  // ERP sync events
  erp_sync: 'ERP-oppdatering',
  erp_created: 'Opprettet i ERP',
  order_created: 'Ordre opprettet',
  order_updated: 'Ordre oppdatert',
  lines_added: 'Varelinjer lagt til',
  lines_removed: 'Varelinjer fjernet',
  status_changed: 'Status endret',
  delivery_date_changed: 'Leveringsdato endret',
  info_changed: 'Notat lagt til',
  reference_changed: 'Referanse endret',
  your_ref_changed: 'Kundens ref endret',
  shipping_changed: 'Frakt endret',
  // Purchase order events
  purchase_order_created: 'Bestilling opprettet',
  purchase_order_sent: 'Bestilling sendt',
  purchase_order_received: 'Bestilling mottatt',
  purchase_order_partial: 'Delvis mottatt',
  purchase_order_email_sent: 'Bestilling sendt per e-post',
  // App events
  order_prepared: 'Klargjort',
  order_delivered: 'Utlevert',
  // Legacy
  status_change: 'Statusendring',
  email_sent: 'E-post sendt',
  sms_sent: 'SMS sendt',
  notification: 'Varsel',
  delivery: 'Levering',
}

interface DotColor {
  bg: string
  icon: string
}

export const timelineDotColors: Record<string, DotColor> = {
  // Status changes
  status_changed: { bg: 'bg-blue-100', icon: 'text-blue-600' },
  status_change: { bg: 'bg-blue-100', icon: 'text-blue-600' },
  order_created: { bg: 'bg-blue-100', icon: 'text-blue-600' },
  order_updated: { bg: 'bg-blue-100', icon: 'text-blue-600' },
  // SMS
  sms_sent: { bg: 'bg-emerald-100', icon: 'text-emerald-600' },
  // Location / prepared
  order_prepared: { bg: 'bg-amber-100', icon: 'text-amber-600' },
  // Delivery
  order_delivered: { bg: 'bg-emerald-50', icon: 'text-emerald-500' },
  delivery: { bg: 'bg-emerald-50', icon: 'text-emerald-500' },
  // Notes / info
  info_changed: { bg: 'bg-yellow-100', icon: 'text-yellow-600' },
  notification: { bg: 'bg-yellow-100', icon: 'text-yellow-600' },
  // Email
  email_sent: { bg: 'bg-violet-100', icon: 'text-violet-600' },
  // Parts / purchase orders
  purchase_order_created: { bg: 'bg-pink-100', icon: 'text-pink-600' },
  purchase_order_sent: { bg: 'bg-pink-100', icon: 'text-pink-600' },
  purchase_order_received: { bg: 'bg-pink-100', icon: 'text-pink-600' },
  purchase_order_partial: { bg: 'bg-pink-100', icon: 'text-pink-600' },
  purchase_order_email_sent: { bg: 'bg-violet-100', icon: 'text-violet-600' },
  lines_added: { bg: 'bg-pink-100', icon: 'text-pink-600' },
  lines_removed: { bg: 'bg-pink-100', icon: 'text-pink-600' },
  // ERP
  erp_sync: { bg: 'bg-gray-100', icon: 'text-gray-500' },
  erp_created: { bg: 'bg-gray-100', icon: 'text-gray-500' },
  // Default fallbacks for other types
  delivery_date_changed: { bg: 'bg-blue-100', icon: 'text-blue-600' },
  reference_changed: { bg: 'bg-blue-100', icon: 'text-blue-600' },
  your_ref_changed: { bg: 'bg-blue-100', icon: 'text-blue-600' },
  shipping_changed: { bg: 'bg-blue-100', icon: 'text-blue-600' },
}

const defaultDotColor: DotColor = { bg: 'bg-gray-100', icon: 'text-gray-500' }

export function getDotColor(eventType: string): DotColor {
  return timelineDotColors[eventType] ?? defaultDotColor
}
